import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgCalendarAdd = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M7.77 2.75a.75.75 0 1 0-1.5 0v5.692a.75.75 0 0 0 1.5 0V6.346h6.365a.75.75 0 0 0 0-1.5H7.769zM4.172 4.846A2.173 2.173 0 0 0 2 7.02v12.808A2.173 2.173 0 0 0 4.173 22h15.654A2.173 2.173 0 0 0 22 19.827V7.019a2.173 2.173 0 0 0-2.173-2.173H17.73V2.75a.75.75 0 1 0-1.5 0v5.692a.75.75 0 0 0 1.5 0V6.346h2.096a.673.673 0 0 1 .673.673v12.808a.673.673 0 0 1-.673.673H4.173a.673.673 0 0 1-.673-.673V7.019a.673.673 0 0 1 .673-.673.75.75 0 0 0 0-1.5m3.52 8.577a.75.75 0 0 1 .75-.75h2.807V9.865a.75.75 0 0 1 1.5 0v2.808h2.808a.75.75 0 0 1 0 1.5H12.75v2.808a.75.75 0 0 1-1.5 0v-2.808H8.442a.75.75 0 0 1-.75-.75"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgCalendarAdd;
